import { createContext } from 'react'

const giftContext = createContext()

export default giftContext
